import "../assets/styles/alarm.css";
import { Alarm } from "./Alarm";

export const Alarms = ({ alarms, addEditItem, onDelete }) => {
  if (!alarms.length) {
    return (
      <p className="text-center">
        There are no alarms yet. Use the plus icon at the top to add some!
      </p>
    );
  }

  return (
    <div className="alarms">
      {alarms
        .sort(
          (a, b) =>
            (a.hours > b.hours ? 1 : a.hours === b.hours ? 0 : -1) ||
            (a.minutes > b.minutes ? 1 : a.minutes === b.minutes ? 0 : -1)
        )
        .map((alarm) => (
          <Alarm
            key={alarm.id}
            alarm={alarm}
            addEditItem={addEditItem}
            onDelete={onDelete}
          />
        ))}
    </div>
  );
};
